import React, {
    createContext,
    useState,
    useMemo,
    useLayoutEffect,
    useEffect,
    useCallback,
} from 'react'

export const PageHeaderContext = createContext({})

export const PageHeaderProvider = ({ children }) => {
    const [breadcrumbs, setBreadcrumbs] = useState([])
    const [pageHeaderActionsContainer, _setPageHeaderActionsContainer] =
        useState(null)
    const [pageHeaderTitleExtras, _setPageHeaderTitleExtras] = useState(null)
    const [loading, setLoading] = useState(false)
    const [title, _setTitle] = useState({})

    // Wrap the setState, because that also accepts a function.
    const setTitle = useCallback(title => {
        _setTitle(() => title)
    }, [])

    const setPageHeaderActionsContainer = useCallback(ref => {
        _setPageHeaderActionsContainer(ref)
    }, [])

    const setPageHeaderTitleExtras = useCallback(ref => {
        _setPageHeaderTitleExtras(ref)
    }, [])

    const contextValue = useMemo(() => {
        return {
            breadcrumbs,
            title,
            setTitle,
            loading,
            setBreadcrumbs,
            pageHeaderActionsContainer,
            setPageHeaderActionsContainer,
            pageHeaderTitleExtras,
            setPageHeaderTitleExtras,
            noTranslation: false,
        }
    }, [
        breadcrumbs,
        title,
        setTitle,
        loading,
        pageHeaderActionsContainer,
        setPageHeaderActionsContainer,
        pageHeaderTitleExtras,
        setPageHeaderTitleExtras,
    ])

    // Update the height of the header. This is to make sure we can provide an accurate "fullscreen" height that is th max size without triggering scrollbars.
    useEffect(() => {
        if (!(title instanceof Function)) {
            setLoading(false)
            return
        }
        const result = title()
        if (result instanceof Promise) {
            setLoading(true)
            result.then(newTitle => {
                setTitle(newTitle)
            })
        }
    }, [setTitle, title])

    // Update the height of the header. This is to make sure we can provide an accurate "fullscreen" height that is th max size without triggering scrollbars.
    useLayoutEffect(() => {
        const header = document.getElementById('mfe-horizon-root-header-region')
        if (header) {
            const computedStyle = getComputedStyle(header)
            const h = String(header.clientHeight)
            if (
                h !==
                computedStyle.getPropertyValue('--root-live-header-height')
            ) {
                document.documentElement.style.setProperty(
                    '--root-live-header-height',
                    `${h}px`
                )
            }
        }
    }, [contextValue.title, contextValue.breadcrumbs])

    return (
        <PageHeaderContext.Provider value={contextValue}>
            {children}
        </PageHeaderContext.Provider>
    )
}
